import { Controller } from "@hotwired/stimulus"
import { applySocialAuthContinuation } from "./support/auth_continuation"

export default class extends Controller {
    connect() {
        this.prepare()
    }

    prepare() {
        applySocialAuthContinuation(this.element)
    }
}
